<template>
<v-container fluid class="tp-page">
  <template v-if="!addQuest">
    <!-- Cabeçalho -->
    <div class="tp-page-head">
      <div>
        <h1 class="tp-page-title">Dispositivos</h1>
        <p class="tp-page-sub">{{ dispositivos.length }} {{ dispositivos.length === 1 ? 'dispositivo' : 'dispositivos' }} no total</p>
      </div>
      <div class="tp-head-actions">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
      </div>
    </div>

    <!-- Tabela -->
    <v-card class="tp-card" elevation="0">
      <v-data-table
        :search="search"
        :headers="headerDisp"
        :items="dispositivos"
        sort-by="titulo"
      >
        <template v-slot:item.ativo="{ item }">
          <td class="text-xs-center">
            <v-icon color="success" v-if="item.ativo">brightness_1</v-icon>
            <v-icon color="error" v-else>brightness_1</v-icon>
          </td>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              small
              class="mr-2"
              @click="editItem(item)"
              color="#00695C"
            >
              input
            </v-icon>
        </template>
        <span>Associar Pesquisa</span>
        </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="carregaDados">Recarregar</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </template>

  <template v-if="addQuest">
<v-stepper v-model="e1" class="tp-card" elevation="0">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Associar Pesquisa</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-row>
            <v-col cols="12" sm="6" md="6">
            <v-text-field disabled v-model="dispositivo.descricao"  outlined label="Descrição" color="#00695C"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="12" md="6">
            <v-select
                outlined
                v-model="dispositivo.questionarioId"
                :items="questionarios"
                item-text="titulo"
                item-value="id"
                label="Pesquisa"
                color="#00695C"
            ></v-select>
            </v-col>

<!--     <v-col cols="12" sm="12" md="6">
            <v-switch
            v-model="dispositivo.ativo"
            :label="`Ativo`"
            color="#00695C"
            ></v-switch>
            </v-col> -->
        </v-row>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn
            color="#00695C"
            text
            large
            @click="addQuest=false"
        >Cancelar</v-btn>
        <v-btn
            color="#00695C"
            dark
            depressed
            rounded
            large
            class="tp-btn-add px-6"
            @click="salvarDisp()"
            >Salvar
        </v-btn>
      </v-card-actions>
        </v-card>
        </v-container>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
  </template>


    <Snackbar ref=chamaSnackbar />
</v-container>
</template>
<script>
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
  export default {
    components: {Snackbar},
    data: () => ({    
      e1: 1,
      search:'',
      addQuest: false,
      headerDisp: [
        {
          text: 'Descrição',
          align: 'start',
          value: 'descricao',
        },
        { text: 'Pesquisa', value: 'questionario' },
        { text: 'Status', value: 'ativo' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      dispositivos: [],
      questionarios: [],
      idDispositivo: '',
      editedIndex: -1,
      editedIndexPerg: -1,
      dispositivo: {
        descricao: '',
        questionario: '',
        questionarioId: '',
        empresaId:''
      },
      defaultDisp: {
        descricao: '',
        questionario: '',
        questionarioId: '',
        empresaId:''
      },    
    }),

    computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,     
    }),

    mounted() {
      this.carregaDados()
    },

    methods: {
     async carregaDados () {
        await axios.get(`${baseApiUrl}Dispositivos?filter[where][empresaId]=${this.companyobj.id}&filter[include]=questionario&access_token=${sessionStorage.getItem('accToken')}`)
                .then(res => {
                    this.dispositivos = []
                    for (var key in res.data) {
                    if (res.data.hasOwnProperty(key)) {
                        this.dispositivos.push({
                        'descricao': res.data[key].descricao,
                        'ativo': res.data[key].ativo,
                        'mac': res.data[key].mac,
                        'questionarioId': res.data[key].questionario.id,
                        'questionario': res.data[key].questionario.titulo,
                        'empresaId': res.data[key].empresaId,
                        'id': res.data[key].id,
                            });
                        }
                      }
                    })

        await axios.get(`${baseApiUrl}Questionarios?filter[where][empresaId]=${this.companyobj.id}&access_token=${sessionStorage.getItem('accToken')}`)
                .then(res => {
                    this.questionarios = res.data
                    })
      },

      editItem (item) {
        this.editedIndex = this.dispositivos.indexOf(item)
        this.idDispositivo = item.id
        this.dispositivo = Object.assign({}, item)
        this.addQuest = true
      },

      async salvarDisp()
      {
        axios.patch(`${baseApiUrl}Dispositivos/${this.idDispositivo}?access_token=${sessionStorage.getItem('accToken')}`, this.dispositivo)
          .then(res => {        
            if(res.data != null){     
                this.carregaDados()
                this.addQuest = false              
            }           	
            }).catch(() => {
                var vm = this;          
                vm.$refs.chamaSnackbar.snack("#FEC8C8","Erro ao realizar operação","#BF4554")
            })
      },      
    },
  }
</script>
<style>
    .textoUser{
        font-weight: bold;
        color: #00253E;
        font-size: 17px;
    }
    @font-face {
     font-family: Roboto;
     src: url('https://fonts.google.com/specimen/Roboto');
    }
    .cssBotao{
        font-weight: bold;
        border-radius: 8px; width: 150px;
        font-size: 7px;
    }
    .theme--light.v-data-table thead tr th{
      color: white;
    }
    
    span.v-stepper__step__step.primary{
    background-color: #00695C!important;
    border-color: #00695C!important;
    }

    .theme--light.v-stepper .v-stepper__label {
        color: #00695C;
    }
    .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
        color: #00695C;
    }
</style>